module.exports = __webpack_public_path__ + "bn.427230e8da6c4e32a7f7.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/bn.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/bn.svg
// module chunks = styles